export const TRANSACTIONS_TAB_PARAM = "transactions";

const METHOD_LABEL_IDS = {
  cash: "gestion.financials.method.cash",
  transfer: "gestion.financials.method.transfer",
  "bank-transfer": "gestion.financials.method.transfer",
  pos: "gestion.financials.method.pos",
  online: "gestion.financials.method.online",
  balance: "gestion.financials.method.balance",
  migrated: "gestion.financials.method.migrated",
};

export const paymentMethodLabel = (method, intl) => {
  if (!method) return null;
  const id = METHOD_LABEL_IDS[method];
  return id ? intl.formatMessage({ id }) : method;
};

const TRANSACTION_STATUS_LABEL_IDS = {
  available: "gestion.financials.transactionStatus.available",
  pending: "gestion.financials.transactionStatus.pending",
};

export const transactionStatusLabel = (status, intl) => {
  if (!status) return "—";
  const id = TRANSACTION_STATUS_LABEL_IDS[String(status).toLowerCase()];
  return id ? intl.formatMessage({ id }) : status;
};

export const transactionUserLabel = (user, intl) => {
  if (user?.kind === "system") return intl.formatMessage({ id: "gestion.financials.systemUser" });
  return user?.name || null;
};

const GATEWAY_NAMES = {
  bancard: "Bancard",
  pagopar: "Pagopar",
  stripe: "Stripe",
  dlocal: "dLocal",
  dlocalgo: "dLocal Go",
  libelula: "Libélula",
  datec: "Datec",
};

export const gatewayName = (provider) => (provider ? GATEWAY_NAMES[provider] || provider : null);

export const maskedCard = (gateway) => {
  if (!gateway?.card_brand && !gateway?.card_last4) return null;
  return [gateway.card_brand, gateway.card_last4 ? `•••• ${gateway.card_last4}` : null].filter(Boolean).join(" ");
};
